// "Click fuera" a prueba de shadow DOM (origen: bug B1, 2026-08-27).
//
// Cuando el bundle corre dentro del shadow root del shell unificado
// (AppMount de quantum-web, ver utils/mountEl.js), e.target de un
// mousedown llega RETARGETADO al host del shadow: contains(e.target) da
// false para CUALQUIER click y el dropdown se cierra en el mousedown,
// antes de que la opción reciba el click (la selección nunca aplicaba).
// composedPath() atraviesa el boundary e incluye los nodos internos.
import { useEffect, useRef } from 'react'

// ¿El evento cae dentro de `el`? composedPath primero (atraviesa shadow
// boundaries); contains como fallback si el evento no lo implementa.
export function eventTargetInside(el, e) {
  if (!el) return false
  const path = typeof e.composedPath === 'function' ? e.composedPath() : []
  return path.length > 0 ? path.includes(el) : el.contains(e.target)
}

// Suscribe un mousedown en document e invoca onOutside solo cuando el
// click cae fuera de TODOS los refs dados.
//
// refs: un ref o array de refs (par input+dropdown, menús con trigger
// separado). enabled permite suscribir solo con el menú abierto.
// El callback vive en un ref: pasar closures inline no re-suscribe el
// listener en cada render.
export function useOutsideClick(refs, onOutside, enabled = true) {
  const callbackRef = useRef(onOutside)
  useEffect(() => { callbackRef.current = onOutside })

  useEffect(() => {
    if (!enabled) return
    const list = Array.isArray(refs) ? refs : [refs]
    const handler = (e) => {
      if (list.some(r => eventTargetInside(r.current, e))) return
      callbackRef.current(e)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [refs, enabled])
}
